import {
  Component,
  ViewEncapsulation,
  OnInit,
  Input, EventEmitter, Output
} from '@angular/core';


@Component({
  selector: 'app-deal-item-detail',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'deal-item-detail.template.html',
})

export class DealItemDetailComponent implements OnInit {
  @Input() public lineItem: any;
  @Input() public rowIndex: number;
  @Output() itemDetailChanged = new EventEmitter<any>();

  appearances = ['large', 'medium', 'small'];
  appearance:string;

  constructor() {
  }

  public propogate() {
    if( this.lineItem.waived) {
      this.lineItem.discount = 0.0;
    }
    console.log("Propogating: " + JSON.stringify(this.lineItem, null,4) + " with " + JSON.stringify(this.rowIndex,null,4));
    this.itemDetailChanged.emit({waived:this.lineItem.waived, discount:this.lineItem.discount, index: this.rowIndex, appearance:this.appearance});
  }

  public ngOnInit(): void {
  }
}
